// START IMPORTS
// Core lib ctx imports
import { AppConfig } from '@ltvco/refresh-lib/ctx';
// Core lib utils imports
import {
  FirstRecordSearch,
  RecordSearchDataWithType,
  getFirstRecordSearch,
} from '@ltvco/refresh-lib/utils';
// Core lib v1 imports
import { useAccount } from '@ltvco/refresh-lib/v1';
// Vendor lib imports
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useState, useEffect, useContext } from 'react';
// END IMPORTS

// START INTERFACES_AND_TYPES
type FirstRecordSearchData =
  | FirstRecordSearch
  | RecordSearchDataWithType
  | null;
// END INTERFACES_AND_TYPES

// START HELPER_FUNCTIONS
export const useFirstRecordSearch = () => {
  const { routingUtils } = useContext(AppConfig);
  const isInFirstPDFVariation = useFeatureIsOn('RFRSH-3379');

  const [firstRecordSearchData] = useState<FirstRecordSearchData>(
    getFirstRecordSearch(routingUtils)
  );

  const { data: account } = useAccount(true);

  const hadFirstSearch = !!firstRecordSearchData;
  const [showFirstTimePDFModal, setFirstTimePDFModal] = useState(false);

  useEffect(() => {
    if (!account) {
      return;
    }

    if (hadFirstSearch) {
      setFirstTimePDFModal(
        isInFirstPDFVariation &&
          !account?.account?.subscription_info?.subscription_features
            ?.pdf_access
      );
    }
  }, [account]);

  return {
    firstRecordSearchData,
    showFirstTimePDFModal,
  };
};
// END HELPER_FUNCTIONS
